// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__H9Kg5","item":"PaymentsMobile_item__3kvkw","label":"PaymentsMobile_label__3uTE-","amount":"PaymentsMobile_amount__2XLr6"};